"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const common_styled_components_1 = require("../../common-styled-components");
const PortTable_1 = require("../common/tables/PortTable");
exports.default = () => {
    return ((0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { align: "left", children: (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(PortTable_1.PortTable, { isInAdminTools: true }) }) }) }));
};
